import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { DataGrid, Dialog } from "../../../components";
import {
  notification,
  ProdutosService,
  SubfamiliaProdutosService,
} from "../../../services";
import { responseErros } from "../../../utils";
import { PermisoesHelper } from "../../../helpers";
import AddSubfamiliaProdutos from "../addSubfamilias/addSubfamilias.view";

const ListSubfamiliaProdutosView = () => {
  const subfamiliaProdutosService = new SubfamiliaProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const produtosService = new ProdutosService();
  const [loading, setLoading] = useState(false);
  const [subfamiliaProdutosId, setSubfamiliaProdutosId] = useState(null);
  const [produtosList, setProdutosList] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [subfamiliasProdutos, setSubfamiliasProdutos] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaSubfamiliasProdutos();
    buscarProdutos();
  }, []);

  const buscaSubfamiliasProdutos = async (query) => {
    const filter = {
      ...query,
    };
    setLoading(true);
    const result = await subfamiliaProdutosService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setSubfamiliasProdutos(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarProdutos = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await produtosService.getAll(filtros);
    if (!res.isAxiosError) {
      setProdutosList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setSubfamiliaProdutosId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSubfamiliaProdutosId(null);
    setOpenDialog(false);
  };

  const sendServerDatagrid = (props) => {
    buscaSubfamiliasProdutos(props.filtros);
  };

  const handleDeleteSubfamiliaProduto = async (id) => {
    const produto = produtosList.some(
      (item) => item.subfamiliaProdutoId === id
    );
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir essa subfamília de produto?`
    );
    if (retornoAlerta.isConfirmed) {
      if (produto) {
        notification.alertaGenericos(
          "Não se pode remover subfamília inserido em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await subfamiliaProdutosService.deletar(id);
      if (!result.isAxiosError) {
        buscaSubfamiliasProdutos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  return (
    <ListLayout
      title="Subfamílias de Produtos"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
    >
      <DataGrid
        rows={subfamiliasProdutos}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={handleDeleteSubfamiliaProduto}
        visualizarShow={permissoesHelper.temPermisao(
          "grupo-produtos-visualizar"
        )}
        editShow={permissoesHelper.temPermisao("grupo-produtos-editar")}
        deleteShow={permissoesHelper.temPermisao("grupo-produtos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <AddSubfamiliaProdutos
          id={subfamiliaProdutosId}
          handleCloseDialog={handleCloseDialog}
          openDialog={openDialog}
          buscaSubfamiliasProdutos={buscaSubfamiliasProdutos}
        />
      </Dialog>
    </ListLayout>
  );
};

export default ListSubfamiliaProdutosView;
